import { render, staticRenderFns } from "./ProductSeriveDetail.vue?vue&type=template&id=2bb8ea23&scoped=true&"
import script from "./ProductSeriveDetail.vue?vue&type=script&lang=js&"
export * from "./ProductSeriveDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductSeriveDetail.vue?vue&type=style&index=0&id=2bb8ea23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8ea23",
  null
  
)

export default component.exports